import styled from 'styled-components';

export const Loading = styled.div`
  padding: 15px;
  background-color: #00BEC1;
  border-radius: 50%;
  display: ${(props) => (props.running ? 'flex' : 'none')};

  > [class^='clap'] {
    margin: 0px auto;
  }
`;
